import { render } from "./indexRu.vue?vue&type=template&id=c8797550&scoped=true&ts=true"
import script from "./indexRu.vue?vue&type=script&lang=ts"
export * from "./indexRu.vue?vue&type=script&lang=ts"

import "./indexRu.vue?vue&type=style&index=0&id=c8797550&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8797550"]])

export default __exports__